var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContractIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-8211a111-42c9-44cb-a62a-608bb1a19b14",
    "data-name": "Capa 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1440 1920",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "uuid-6385190d-15d0-40e2-9f7b-df2b2096705e",
    d: "M1248,0H192C85.97,0,0,85.97,0,192v1536c0,106.03,85.97,192,192,192h1056c106.03,0,192-85.97,192-192V192c0-106.03-85.97-192-192-192ZM1344,1728c0,52.95-43.08,96-96,96H192c-52.95,0-96-43.05-96-96V192c0-52.95,43.05-96,96-96h724.97v334.69l118.2-115.22,118.17,115.22V96h94.66c52.92,0,96,43.05,96,96v1536Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-6385190d-15d0-40e2-9f7b-df2b2096705e",
    d: "M1198.45,601.8H248.81c-26.53,0-48,21.47-48,48s21.47,48,48,48h949.64c26.53,0,48-21.47,48-48s-21.47-48-48-48Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-6385190d-15d0-40e2-9f7b-df2b2096705e",
    d: "M1198.45,823.8H248.81c-26.53,0-48,21.47-48,48s21.47,48,48,48h949.64c26.53,0,48-21.47,48-48s-21.47-48-48-48Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-6385190d-15d0-40e2-9f7b-df2b2096705e",
    d: "M1198.45,1045.71H248.81c-26.53,0-48,21.47-48,48s21.47,48,48,48h949.64c26.53,0,48-21.47,48-48s-21.47-48-48-48Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-6385190d-15d0-40e2-9f7b-df2b2096705e",
    d: "M1198.45,1267.71H248.81c-26.53,0-48,21.47-48,48s21.47,48,48,48h949.64c26.53,0,48-21.47,48-48s-21.47-48-48-48Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "uuid-6385190d-15d0-40e2-9f7b-df2b2096705e",
    d: "M743.58,1489.71H248.81c-26.53,0-48,21.47-48,48s21.47,48,48,48h494.77c26.53,0,48-21.47,48-48s-21.47-48-48-48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContractIcon);
export default __webpack_public_path__ + "static/media/ContractIcon.15abb38d87760f3959b414ec1cecb738.svg";
export { ForwardRef as ReactComponent };